(() => {
  if (window.DaramelSectionReveal) {
    window.DaramelSectionReveal.init(document);
    return;
  }

  const initialized = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function reveal(section) {
    if (section.dataset.animate !== 'true' || reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        section.classList.add('is-visible');
        observer.disconnect();
      },
      { rootMargin: '0px 0px -8%', threshold: 0.12 }
    );

    observer.observe(section);
  }

  function init(root = document) {
    const sections = root.matches?.('[data-section-reveal]')
      ? [root]
      : root.querySelectorAll('[data-section-reveal]');

    sections.forEach((section) => {
      if (initialized.has(section)) return;
      initialized.add(section);
      reveal(section);
    });
  }

  window.DaramelSectionReveal = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
